import { emptys } from "../../../data/main";
import { stdObject } from "../../../data/types/stdObject";

const hasDuplicates = (
  arr: Array<stdObject>,
  values: Array<[string, string]>,
) => {
  return (
    arr.filter((e) =>
      values.every((o: [string, string]) => o[0] in e && e[o[0]] === e[1]),
    ).length > 1
  );
};

const haveEmptyDates = (arr: Array<stdObject>, value: number) => {
  return arr.some((o: stdObject) => {
    const paramExists =
      value === 1
        ? !("DATES" in o) || emptys.includes(o.DATES[0])
        : !("DAYS" in o) ||
          o.DAYS.some((v: Array<string>) => emptys.includes(v[0]));
    return "DATOFE" in o && Number(o.DATOFE) === value && paramExists;
  });
};

const hasDatesDuplicates = (arr: Array<stdObject>, fixed: boolean) => {
  let data: stdObject = { f1: {}, f2: {}, repeated: false };
  arr.forEach((e) => {
    if (!data.repeated) {
      Array(2)
        .fill(null)
        .forEach((_, index: number) => {
          const idx = index + 1;
          const paramExists = fixed
            ? `MON${idx}OFE` in e &&
              !emptys.includes(e[`MON${idx}OFE`]) &&
              `DAY${idx}OFE` in e &&
              !emptys.includes(e[`DAY${idx}OFE`])
            : `FEC${idx}OFE` in e && !emptys.includes(e[`FEC${idx}OFE`]);
          if (paramExists) {
            const code = fixed
              ? e[`MON${idx}OFE`] + "," + e[`DAY${idx}OFE`]
              : e[`FEC${idx}OFE`];
            if (code in data[`f${idx}`]) {
              if (data[`f${idx}`][code].includes(e.TAROFE)) {
                data.repeated = true;
              } else {
                data[`f${idx}`][code].push(e.TAROFE);
              }
            } else {
              if (e.TAROFE === "0") {
                data[`f${idx}`][code] = [e.TAROFE];
              } else {
                data[`f${idx}`][code] = ["0", e.TAROFE];
              }
            }
          }
        });
    }
  });
  return data.repeated;
};

const hasOverlap = (ranges: Array<stdObject>) => {
  return ranges.some((r1, i) =>
    ranges.slice(i + 1).some((r2) => {
      if (
        "FEC1OFE" in r1 &&
        r1.FEC1OFE !== "" &&
        "FEC2OFE" in r1 &&
        r1.FEC2OFE !== "" &&
        "FEC1OFE" in r2 &&
        r2.FEC1OFE !== "" &&
        "FEC2OFE" in r2 &&
        r2.FEC2OFE !== ""
      ) {
        const start1 = new Date(r1.FEC1OFE);
        const end1 = new Date(r1.FEC2OFE);
        const start2 = new Date(r2.FEC1OFE);
        const end2 = new Date(r2.FEC2OFE);
        return (
          r1.DATOFE === "1" &&
          r2.DATOFE === "1" &&
          start1 <= end2 &&
          start2 <= end1
        );
      }
      return false;
    }),
  );
};

export const checkIfOfferOk = (offers: stdObject) => {
  let returnData = { ok: true, msg: "" };
  Object.keys(offers).forEach((e: string) => {
    let offersList = offers[e];
    [
      "offerValueEmpty",
      "offersAlwaysDuplicated",
      "offerDateEmpty",
      "offerDateFixedEmpty",
      "offersDatesRepeated",
      "offersDatesFixedRepeated",
      "offersDatesOverlay",
      "offersDaysRepeated",
      "offerDayNoSelected",
    ].forEach((v: string) => {
      if (returnData.ok) {
        switch (v) {
          case "offerValueEmpty":
            returnData.ok = offersList.every(
              (o: stdObject) =>
                ("PREOFE" in o && Number(o.PREOFE) !== 0) ||
                ("POROFE" in o && Number(o.POROFE) !== 0),
            );
            break;
          case "offersAlwaysDuplicated":
            returnData.ok = !hasDuplicates(offersList, [["DATOFE", "0"]]);
            break;
          case "offerDateEmpty":
          case "offerDateFixedEmpty":
            returnData.ok = !haveEmptyDates(
              offersList,
              v === "offerDateEmpty" ? 1 : 2,
            );
            break;
          case "offersDatesRepeated":
          case "offersDatesFixedRepeated":
            returnData.ok = !hasDatesDuplicates(
              offersList,
              v === "offersDatesFixedRepeated",
            );
            break;
          case "offersDatesOverlay":
            returnData.ok = !hasOverlap(offersList);
            break;
          case "offersDaysRepeated":
            Array(7)
              .fill(null)
              .forEach((_, index: number) => {
                if (returnData.ok) {
                  returnData.ok = !hasDuplicates(offersList, [
                    ["DATOFE", "3"],
                    [`D${index}OFE`, "1"],
                  ]);
                }
              });
            break;
          case "offerDayNoSelected":
            console.log("rr", offersList);
            returnData.ok = !offersList.some(
              (o: stdObject) =>
                "DATOFE" in o &&
                Number(o.DATOFE) === 3 &&
                "WEEK" in o &&
                Array(7)
                  .fill(null)
                  .every((_, index: number) => emptys.includes(o.WEEK[index])),
            );
            break;
        }

        if (!returnData.ok) {
          returnData.msg = v;
        }
      }
    });
  });
  return returnData;
};
